import {Injectable} from "@angular/core";
import {UrlBuilder} from "../url-builder/url.builder";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {WifiMenuData} from "./wifimenudata";

@Injectable({
  providedIn: 'root'
})
export class WifiMenuDataService {

  private uiUrl: string = "";
  private url: UrlBuilder;

  constructor(private http: HttpClient) {
    this.url = new UrlBuilder();
  }


  GetData(): Observable<WifiMenuData> {
    this.uiUrl = this.url.GetWifiMenuDataUrl()
    console.log('FILE: ' + this.uiUrl);
    return this.http.get<WifiMenuData>(this.uiUrl);
  }


}

